var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "aboutus-page" },
    [
      _c("header-cmp"),
      _vm._v(" "),
      _c("section", { staticClass: "page-part banner banner_aboutus" }),
      _vm._v(" "),
      _c("section", { staticClass: "page-part page-container" }, [
        _c("div", { staticClass: "page-inner" }, [
          _c("aside", { ref: "menu", staticClass: "menu" }, [
            _c(
              "ul",
              _vm._l(_vm.menuList, function(item, index) {
                return _c(
                  "li",
                  {
                    key: index,
                    staticClass: "menu-item",
                    class: _vm.activedIndex == index ? "active" : "",
                    on: {
                      click: function($event) {
                        return _vm.clickMenuHandler(item, index)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n            " + _vm._s(item.alias) + "\n          "
                    )
                  ]
                )
              }),
              0
            )
          ]),
          _vm._v(" "),
          _c(
            "article",
            { ref: "content", staticClass: "inline-block content" },
            [
              _c(
                "section",
                { staticClass: "inline-block", attrs: { id: "jianjie" } },
                [
                  _c("h3", { staticClass: "section-title" }, [
                    _vm._v("公司简介")
                  ]),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      staticClass: "section-desc inline-block",
                      staticStyle: {
                        width: "415px",
                        "margin-right": "10px",
                        "vertical-align": "unset"
                      }
                    },
                    [
                      _vm._v(
                        "\n            杭州享运供应链管理有限公司是一家基于大数据的大宗商品智能车货匹配交易平台。截止2017年6月平台已有7000多用户，与浙江物产、宝钢、吉利汽车等世界500强企业及乐钢、找钢、欧冶及塑料领域的优秀大宗电商企业达成了战略合作伙伴关系。享运基础物流产品不断创新，于2016年11月“享运货主”、“享运司机”车货匹配交易APP正式上线同时开发了微信版和PC版。系统下单简洁，快速派车，安装享运司机的司机端北斗定位实时反馈给货主。享运APP解决了货主找车难、司机找货难得问题，提高了司机的接单频次，减少了司机的空驶现象，降低了社会的能耗，让物流更低碳。同时平台提供给货主和司机的双方保障。享运平台粘性产品不断创新，享运要“做最好的物流服务商，打造一流的供应链体系”。\n          "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "relative inline-block" }, [
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.hiddenVideo,
                          expression: "hiddenVideo"
                        }
                      ],
                      staticClass: "section-img inline-block",
                      staticStyle: {
                        width: "500px",
                        "vertical-align": "super",
                        cursor: "pointer"
                      },
                      attrs: {
                        src: require("../assets/images/page_aboutus/video_snapshot.png")
                      }
                    }),
                    _vm._v(" "),
                    _c("video", {
                      ref: "introVideo",
                      staticClass: "section-img",
                      staticStyle: {
                        width: "500px",
                        "vertical-align": "super"
                      },
                      attrs: {
                        preload: "",
                        controls: "",
                        loop: "",
                        hidden: _vm.hiddenVideo,
                        src:
                          "http://www.clfirst.com/videos/ceo_introduction.6a89b70.mp4"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.hiddenVideo,
                            expression: "hiddenVideo"
                          }
                        ],
                        staticClass: "banner-cover",
                        on: { click: _vm.playVideo }
                      },
                      [_c("i", { staticClass: "icon icon-play" })]
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _vm._m(0),
              _vm._v(" "),
              _vm._m(1),
              _vm._v(" "),
              _vm._m(2),
              _vm._v(" "),
              _vm._m(3),
              _vm._v(" "),
              _vm._m(4),
              _vm._v(" "),
              _c("p", { staticClass: "hotline" }, [
                _vm._v("全国服务热线：0571-88769096")
              ])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("footer-cmp")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { attrs: { id: "licheng" } }, [
      _c("h3", { staticClass: "section-title" }, [_vm._v("发展历程")]),
      _vm._v(" "),
      _c("div", { staticClass: "pairs" }, [
        _c("span", { staticClass: "key" }, [_vm._v("2010")]),
        _vm._v(" "),
        _c("span", { staticClass: "value" }, [
          _vm._v(
            "章双荷2008年毕业于浙江工商大学（杭商院）首届物流管理专业，先后供职过宅急送和华冶钢铁，随后创办了观海物流。"
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "pairs" }, [
        _c("span", { staticClass: "key" }, [_vm._v("2011")]),
        _vm._v(" "),
        _c("span", { staticClass: "value" }, [
          _vm._v("全国服务热线0571-88769096开通，购买了第一辆卡车。")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "pairs" }, [
        _c("span", { staticClass: "key" }, [_vm._v("2012")]),
        _vm._v(" "),
        _c("span", { staticClass: "value" }, [
          _vm._v("观海企业QQ开通，对外统一形象窗口对内统一管理 。")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "pairs" }, [
        _c("span", { staticClass: "key" }, [_vm._v("2013")]),
        _vm._v(" "),
        _c("span", { staticClass: "value" }, [
          _vm._v("观海物流的图形商标下证，业绩突破1000万。")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "pairs" }, [
        _c("span", { staticClass: "key" }, [_vm._v("2014")]),
        _vm._v(" "),
        _c("span", { staticClass: "value" }, [
          _vm._v("与吉利汽车和宝钢签订运输战略协议，观海物流微信公众号开通。")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "pairs" }, [
        _c("span", { staticClass: "key" }, [_vm._v("2015")]),
        _vm._v(" "),
        _c("span", { staticClass: "value" }, [
          _vm._v(
            "观海物流“观海”的文字商标下证，第一个合伙人加入观海，提出了“物流+互联网”的发展思路，注册成立“杭州享运供应链管理有限公司”，进行线上运营，与观海物流线上模式结合\n              ，线上线下同步发展。"
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "pairs" }, [
        _c("span", { staticClass: "key" }, [_vm._v("2016")]),
        _vm._v(" "),
        _c("span", { staticClass: "value" }, [
          _vm._v(
            "2016年是观海的拐点，今年7月份观海旗下产品“享运网”APP和微信端面世，届时广大客户可以通过APP和微信下单，业务覆盖全国，遵循价格更优和承运效率更高的原则，更好的服务广大客户。\n              杭州享运供应链管理有限公司属于杭州观海物流有限公司的全资子公司，注册资金500万，由原观海物流的原班人马打造。"
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "pairs" }, [
        _c("span", { staticClass: "key" }, [_vm._v("2017")]),
        _vm._v(" "),
        _c("span", { staticClass: "value" }, [_vm._v("敬请期待……")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { attrs: { id: "yuanjing" } }, [
      _c("h3", { staticClass: "section-title" }, [_vm._v("企业愿景")]),
      _vm._v(" "),
      _c("p", [_vm._v("成为最卓越的大宗商品智能物流平台！")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { attrs: { id: "shiming" } }, [
      _c("h3", { staticClass: "section-title" }, [_vm._v("企业使命")]),
      _vm._v(" "),
      _c("p", [_vm._v("让物流更美好、更高效、更智能！")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { attrs: { id: "jiazhiguan" } }, [
      _c("h3", { staticClass: "section-title" }, [_vm._v("价值观")]),
      _vm._v(" "),
      _c("p", [_vm._v("客户至上 激情快乐 创新思维 高效执行")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { attrs: { id: "lianxi" } }, [
      _c("h3", { staticClass: "section-title" }, [_vm._v("联系我们")]),
      _vm._v(" "),
      _c("h4", { staticClass: "section-title_sub" }, [
        _vm._v("杭州享运供应链管理有限公司")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "section-desc" }, [
        _vm._v("地址：浙江省杭州市余杭区良渚街道网周路99号1幢1901室 ")
      ]),
      _vm._v(" "),
      _c("div", { attrs: { id: "map-wrap" } }, [
        _c("img", {
          staticClass: "map",
          attrs: { src: require("@/assets/images/gsdz.png"), alt: "" }
        })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-b932777e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-b932777e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/aboutus.vue
// module id = null
// module chunks = 